import { Entypo } from "@expo/vector-icons";
import React, { useState } from "react";
import { ActivityIndicator } from "react-native";
import { Dimensions, StyleSheet } from "react-native";
import { Button } from "react-native-elements";
import { RFValue } from "react-native-responsive-fontsize";
import saveFileAsync from "../functions/saveFileAsync";

const DownloadButton = ({ name, document, fileName }) => {
  const [loading, setLoading] = useState(false);
  return (
    <Button
      title="Download"
      disabled={loading}
      iconRight
      icon={
        loading ? (
          <ActivityIndicator animating color="black" style={styles.icon} />
        ) : (
          <Entypo name="download" size={20} color="white" style={styles.icon} />
        )
      }
      buttonStyle={styles.buttonStyle}
      titleStyle={styles.buttonTitle}
      onPress={async () => {
        setLoading(true);
        await saveFileAsync(name, document, fileName);
        setLoading(false);
      }}
    />
  );
};

export default DownloadButton;

const styles = StyleSheet.create({
  buttonTitle: { fontSize: RFValue(9), fontFamily: "avenir" },
  buttonStyle: {
    alignSelf: "center",
    marginVertical: 10,
    padding: 10,
    borderRadius: 10,
    backgroundColor: "#2E3339",
  },
  icon: { marginLeft: 10 },
});
